/**
 * IMAYO Journal Article - TOC auto-generation & smooth scroll
 * Scans h2/h3 headings in article content, builds a table of contents,
 * and provides smooth scrolling to each heading on click.
 */
(function () {
  'use strict';

  function init() {
    generateTOC();
  }

  function generateTOC() {
    var content = document.getElementById('journal-article-content');
    var tocContainer = document.getElementById('journal-toc');
    var tocInner = document.getElementById('journal-toc-inner');
    if (!content || !tocContainer || !tocInner) return;

    var headings = content.querySelectorAll('h2, h3');
    if (headings.length === 0) {
      tocContainer.style.display = 'none';
      return;
    }

    var html = buildTOCHTML(headings);
    tocInner.innerHTML = html;
    attachScrollEvents(tocInner);
    createMobileTOC(content, html);
  }

  function createMobileTOC(content, tocHTML) {
    var mobileToc = document.createElement('div');
    mobileToc.className = 'journal-article-toc -mobile';
    mobileToc.innerHTML =
      '<span class="journal-article-toc-heading">index</span>' +
      '<div class="journal-article-toc-inner">' + tocHTML + '</div>';
    var lead = content.querySelector('.article-lead');
    if (lead) {
      lead.after(mobileToc);
    } else {
      var firstH2 = content.querySelector('h2');
      if (firstH2) {
        firstH2.before(mobileToc);
      }
    }
    attachScrollEvents(mobileToc.querySelector('.journal-article-toc-inner'));
  }

  function buildTOCHTML(headings) {
    var html = '<ul class="toc-list">';
    var h2Count = 0;

    headings.forEach(function (heading, index) {
      var id = 'journal-heading-' + index;
      heading.id = id;
      var text = heading.textContent.trim();

      if (heading.tagName === 'H2') {
        h2Count++;
        html += '<li class="toc-item">';
        html += '<a href="#' + id + '" class="toc-link">';
        html += '<span class="toc-number">' + h2Count + '.</span> <span class="toc-text">' + text + '</span>';
        html += '</a></li>';
      } else {
        html += '<li class="toc-item toc-item-sub">';
        html += '<a href="#' + id + '" class="toc-link"><span class="toc-text">' + text + '</span></a>';
        html += '</li>';
      }
    });

    html += '</ul>';
    return html;
  }

  function attachScrollEvents(tocInner) {
    tocInner.addEventListener('click', function (e) {
      var link = e.target.closest('.toc-link');
      if (!link) return;
      e.preventDefault();
      var targetId = link.getAttribute('href').substring(1);
      var target = document.getElementById(targetId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
